const MainPage = {
	title: 'Feature Requests',
	subtitle: 'Join other users in helping make it better',
	login: 'Enter',
	search: 'Search',
	no_results: 'No suggestions found'
}

export default MainPage;